import React from 'react';
import { Stack, Typography, IconButton, Box, Avatar } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import BusinessIcon from '@mui/icons-material/Business';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { Settings } from '@mui/icons-material';

const roleIcons = {
  EMPLOYEE: <PersonIcon />,
  HR: <GroupIcon />,
  RMG: <BusinessIcon />,
  MANAGER: <ManageAccountsIcon />,
  CUSTOM: <Settings />,
};

const SettingsHeader = ({ role, onBack }) => {
  return (
    <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: '6px', ml: '9px' }}>
      <IconButton onClick={onBack} size="small" sx={{ bgcolor: 'grey.200' }}>
        <ArrowBackIcon />
      </IconButton>
      <Avatar sx={{ bgcolor: 'primary.main', height: 30, width: 30 }}>{roleIcons[role]}</Avatar>
      <Typography variant="h6">Settings for {role}</Typography>
    </Stack>
  );
};

export default SettingsHeader;
